

define(['squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index'], function (squid, template) {

    squid.module('xo-pay-with-credit.directive', ['squid', 'xomodel.checkout']).directive('xoPayWithCredit', function () {
        return {
            template: template,

            restrict: 'E',

            scope: {
                token: '=',
                doneFn: '='
            },

            controller: function controller($scope, $populate, $state, $CheckoutCartModel, $CheckoutSessionModel, $locale, $window, $logger, $config) {

                var stateName = 'gce_pay_with_credit';

                $populate($scope, {
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
                }).then(function () {

                    // For US and GB if txn amount is >= 99 or 150 resp show pay with credit option if credit in
                    // wallet and is not the current funding option

                    // required to avoid looging every digest cycle.
                    // TODO: remove this when debounce is fixed for logger
                    var offerShown = false;

                    $scope.showPayWithCredit = function () {

                        if (!$scope.checkoutCart.get('purchase.amounts.total.amount')) {
                            offerShown = false;
                            return false;
                        }

                        var amount = parseFloat($scope.checkoutCart.purchase.amounts.total.amount);
                        var minAmount = $window.config.minCreditAmtNoInterest[$locale.country];
                        var hasCredit = $scope.checkoutSession.fundingOptions.hasCredit();
                        var fundingSource = $scope.checkoutSession.plan.sources;
                        var showOffer = $config.features.DEFAULT.showPayWithCreditOffer && !$scope.checkoutSession.plccOffer;

                        if (showOffer && minAmount && amount >= minAmount && hasCredit) {
                            for (var i in fundingSource) {
                                if (fundingSource[i].type === 'BILL_ME_LATER') {
                                    offerShown = false;
                                    return false;
                                }
                            }
                            if (!offerShown) {
                                $logger.info(stateName + '_offer_shown');
                            }
                            offerShown = true;
                            return true;
                        }
                        offerShown = false;
                        return false;
                    };

                    $scope.onSubmit = function () {

                        $logger.info(stateName + '_offer_clicked');

                        $scope.checkoutSession.message = null;

                        var instruments = $scope.checkoutSession.fundingOptions.instruments;
                        var creditPlanId;

                        for (var i in instruments) {
                            if (instruments[i].type === 'CREDIT' && instruments[i].name === 'BILL_ME_LATER') {
                                creditPlanId = instruments[i].planId;
                            }
                        }

                        if (!creditPlanId) {
                            $logger.info(stateName + '_credit_planid_not_found');
                            return;
                        }

                        $scope.checkoutSession.fundingOptions.action('select', {

                            resultModel: $scope.checkoutSession,
                            data: {
                                planId: creditPlanId
                            },

                            success: function success(result) {

                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
                                };
                                $logger.info(stateName + '_success');
                            }
                        });
                    };
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/pay-with-credit/directive.js
// module id = ./components/xo-credit-components/src/pay-with-credit/directive.js
// module chunks = 1